const mutations = {
  
    ADD_GRADE_CURRICULAR (state, value) {

        state.gradecurricular.push(value)

    },

    ALL_GRADE_CURRICULLAR (state, value) {

        state.gradecurricular = value

    },
    SET_GRADE_CURRICULLAR (state, value) {

        state.dados_gradecurricular = value

    },
    ALL_OFERTA_GRADE_CURRICULLAR (state, value) {

        state.lista_grade_oferta_disciplina = value

    },
    SETAR_GRADE_CURRICULLAR (state, value) {

        state.Setargradecurricular = value

    },
}

export default mutations